
import React from 'react';
import { Skeleton } from "@/components/ui/skeleton";
import FlatDashboardCard from '@/components/ui/FlatDashboardCard';

const ProfileSidebarSkeleton = () => {
  return (
    <FlatDashboardCard>
      <div className="flex flex-col items-center gap-6 p-4">
        {/* Avatar Skeleton */}
        <Skeleton className="h-24 w-24 rounded-full" />
        
        {/* Info Skeleton */}
        <div className="w-full space-y-4">
          <div className="flex flex-col items-center gap-2">
            <Skeleton className="h-5 w-40" />
            <Skeleton className="h-4 w-24" />
          </div>
          
          <div className="space-y-3 w-full">
            <div className="flex items-center gap-2">
              <Skeleton className="h-7 w-7 rounded-full" />
              <div className="flex flex-col flex-1">
                <Skeleton className="h-3 w-20 mb-1" />
                <Skeleton className="h-4 w-32" />
              </div>
            </div>
            
            <div className="flex items-center gap-2">
              <Skeleton className="h-7 w-7 rounded-full" />
              <div className="flex flex-col flex-1">
                <Skeleton className="h-3 w-20 mb-1" />
                <Skeleton className="h-4 w-48" />
              </div>
            </div>
            
            <div className="flex items-center gap-2">
              <Skeleton className="h-7 w-7 rounded-full" />
              <div className="flex flex-col flex-1">
                <Skeleton className="h-3 w-20 mb-1" />
                <Skeleton className="h-4 w-32" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </FlatDashboardCard>
  );
};

export default ProfileSidebarSkeleton;
